import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { EventEmitter, Injectable, Injector, TemplateRef } from '@angular/core';
import {
  DRAWER_PANEL_CONFIG,
  DRAWER_PANEL_DATA,
  DrawerPanelComponent,
  DrawerPanelConfig,
} from '../components/drawer-panel/drawer-panel.component';
import { DrawerPanelRef } from './drawer-panel.ref';

@Injectable()
export class DrawerPanelService {
  constructor(
    private injector: Injector,
    private overlay: Overlay,
  ) {}

  open<T extends ComponentType<any> | TemplateRef<any>, D>(component: T, data?: D, onHide?: EventEmitter<void>) {
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
    });

    const drawerPanelRef = new DrawerPanelRef(overlayRef, onHide);

    const config: DrawerPanelConfig = {
      component,
      drawerRef: drawerPanelRef,
      onHide,
    };

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: DRAWER_PANEL_CONFIG, useValue: config },
        { provide: DRAWER_PANEL_DATA, useValue: data || null },
      ],
    });

    overlayRef.attach(new ComponentPortal(DrawerPanelComponent, null, injector));
    overlayRef.backdropClick().subscribe(_ => {
      drawerPanelRef.close();
    });

    return drawerPanelRef;
  }
}
